import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/Home/WhyChooseUs.css';

const WhyChooseUs = () => {
  const reasons = [
    {
      id: 1,
      icon: 'bi-star',
      title: 'Industry Expertise',
      description: '15+ years of experience delivering cutting-edge IT solutions across various industries.',
      count: 15,
      suffix: '+ Years'
    },
    {
      id: 2,
      icon: 'bi-people',
      title: 'Expert Team',
      description: 'Certified professionals with deep technical knowledge and industry experience.',
      count: 50,
      suffix: '+ Experts'
    },
    {
      id: 3,
      icon: 'bi-check-circle',
      title: 'Proven Track Record',
      description: 'Successfully delivered 500+ projects with 98% client satisfaction rate.',
      count: 500,
      suffix: '+ Projects'
    },
    {
      id: 4,
      icon: 'bi-shield-check',
      title: 'Quality Assurance',
      description: 'Rigorous quality processes ensuring reliable and scalable solutions.',
      count: 100,
      suffix: '% Quality'
    }
  ];

  useEffect(() => {
    // Animation for counters
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const counters = entry.target.querySelectorAll('.counter');
            counters.forEach(counter => {
              const target = +counter.getAttribute('data-target');
              const increment = target / 100;
              let current = 0;
              
              const updateCounter = () => {
                if (current < target) {
                  current += increment;
                  counter.textContent = Math.ceil(current) + (counter.getAttribute('data-suffix') || '');
                  setTimeout(updateCounter, 20);
                } else {
                  counter.textContent = target + (counter.getAttribute('data-suffix') || '');
                }
              };
              
              updateCounter();
            });
          }
        });
      },
      { threshold: 0.5 }
    );

    const section = document.querySelector('.why-choose-us');
    if (section) observer.observe(section);

    return () => observer.disconnect();
  }, []);

  return (
    <section className="why-choose-us section-padding">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 mb-5 mb-lg-0">
            <div className="why-content">
              <span className="section-label">Why Choose Us</span>
              <h2 className="section-title">Your Trusted Technology Partner</h2>
              <p className="why-text">
                We combine technical expertise with business understanding to deliver solutions 
                that drive growth, enhance efficiency, and secure your digital assets.
              </p>
              
              <div className="reasons-list">
                {reasons.map((reason) => (
                  <div className="reason-item" key={reason.id}>
                    <div className="reason-icon">
                      <i className={`bi ${reason.icon}`}></i>
                    </div>
                    <div className="reason-content">
                      <h4>{reason.title}</h4>
                      <p>{reason.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              
              <div className="why-cta">
                <Link to="/about" className="btn btn-primary">
                  Learn More About Us
                </Link>
                <Link to="/contact" className="btn btn-outline-primary ms-3">
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
          
          <div className="col-lg-6">
            <div className="why-image">
              <div className="image-container">
                <div className="main-image">
                  <img 
                    src="https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=1350&q=80" 
                    alt="Why Choose Pentagram Infotech"
                  />
                </div>
                
                {/* Counter Cards */}
                <div className="counter-card card-1">
                  <h3 className="counter" data-target="25" data-suffix="+">25+</h3>
                  <p>Years Experience</p>
                </div>
                
                <div className="counter-card card-2">
                  <h3 className="counter" data-target="500" data-suffix="+">500+</h3>
                  <p>Projects Delivered</p>
                </div>
                
                <div className="counter-card card-3">
                  <h3 className="counter" data-target="200" data-suffix="+">200+</h3>
                  <p>Happy Clients</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;